import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {ThreadListItem} from 'shells/inbox/page/thread-list-item/thread-list-item';
import {ListViewPaginated} from 'shells/list-view/list-view-paginated';
import {SearchBar} from 'shells/search-bar/search-bar';
import {Body} from 'shells/typography/body';

import type {InboxThreadFragment} from 'nutshell-graphql-types';

import {getThreadListEmptyStateText} from '../helpers';

import styles from './inbox-page.module.css';

type Props = ContextRouter & {
    selectedView: string | null | undefined;
    latestThreads: InboxThreadFragment[];
    hasNextPage: boolean;
    fetchMoreRows: () => any;
    isLoading: boolean;
    selectedThread: InboxThreadFragment | null | undefined;
    setSelectedThread: (arg1: InboxThreadFragment) => void;
    search?: string;
    onSearchChange?: (value: string) => void;
    isSearchOpen?: boolean;
};

export function ThreadList(props: Props) {
    const {latestThreads, isLoading, selectedThread, setSelectedThread} = props;

    const emptyStateText = props.search
        ? 'No results found'
        : getThreadListEmptyStateText(props.selectedView);

    return (
        <div className={styles['thread-list-container']}>
            {props.isSearchOpen && props.onSearchChange && (
                <div className={styles['thread-list-search']}>
                    <SearchBar
                        onChange={props.onSearchChange}
                        value={props.search || ''}
                        placeholder='Search threads…'
                        isClearable={true}
                        hasBorder={true}
                        autoFocus={true}
                    />
                </div>
            )}
            <div className='full-height pos-relative overflow-y-auto overflow-x-hidden'>
                <ListViewPaginated
                    hasNextPage={props.hasNextPage}
                    onFetchMoreRows={props.fetchMoreRows}
                    isLoading={isLoading}
                    specialStates={[
                        {
                            shouldRender: () => isLoading,
                            component: (
                                <div className='mt-64 text-align-center'>
                                    <Body size='normal' color='light'>
                                        Loading…
                                    </Body>
                                </div>
                            ),
                        },
                        {
                            shouldRender: () => !isLoading && latestThreads.length === 0,
                            component: (
                                <div className='mt-64 text-align-center'>
                                    <Body size='normal' color='medium'>
                                        {emptyStateText}
                                    </Body>
                                </div>
                            ),
                        },
                    ]}
                    collection={latestThreads}
                    renderRow={(thread) => (
                        <div className={styles['thread-list-item-wrapper']}>
                            <ThreadListItem
                                id={thread.id}
                                key={thread.id}
                                thread={thread}
                                isSelected={Boolean(
                                    selectedThread && selectedThread.id === thread.id
                                )}
                                onSelect={() => setSelectedThread(thread)}
                            />
                        </div>
                    )}
                />
            </div>
        </div>
    );
}
